<div class="edit-account-root">
<div class="edit-account-header d-flex">
    <div class="user-header-info">
      <div class="user-info">
        <div class="name">
          {{
          serviceRequestTrackerDetails?.accountKyc?.surname +
          " " +
          serviceRequestTrackerDetails?.accountKyc?.firstName
          }}
        </div>
        <div class="application-number">
          {{ serviceRequestTrackerDetails?.accountKyc?.applicationNumber }}
        </div>
        <div class="edit-accounts-body row">
          <div class="col-12">
            <div class="row">
              <div [ngClass]="{
                  'col-4': serviceRequestTrackerDetails?.siteVerification?.accountCreationStatus,
                  'col-12': !serviceRequestTrackerDetails?.siteVerification?.accountCreationStatus
                }" *ngIf="!serviceRequestTrackerDetails?.accountKyc?.accountNumber">
                <div class="entry-status new-entry">
                  {{ "COMMON.FILTER_BY_OPTIONS.NEW" | translate }}
                </div>
              </div>
              <div *ngIf="serviceRequestTrackerDetails?.accountKyc?.accountNumber" [ngClass]="{
                  'col-4': serviceRequestTrackerDetails?.siteVerification?.accountCreationStatus,
                  'col-12': !serviceRequestTrackerDetails?.siteVerification?.accountCreationStatus
                }">
                <div class="entry-status existing-entry">
                  {{ "COMMON.FILTER_BY_OPTIONS.EXISTING" | translate }}
                </div>
              </div>

            <div *ngIf="serviceRequestTrackerDetails?.siteVerification?.permiseType" [ngClass]="{
                  'col-8 header-second-column':
                    serviceRequestTrackerDetails?.siteVerification?.accountCreationStatus,
                  'col-12': !serviceRequestTrackerDetails?.siteVerification?.accountCreationStatus
                }">
                <div class="account-status approval-status new-entry">
                {{ serviceRequestTrackerDetails?.siteVerification?.permiseType }}
                </div>
              </div>
            </div>

            <div class="row" *ngIf="serviceRequestTrackerDetails?.siteVerification?.status">
              <div class="col-4">
                <div class="account-status" [ngClass]="{
                    'unvalidated-building':
                      serviceRequestTrackerDetails?.siteVerification?.status?.toString() === 'New',
                    'assigned-building':
                      serviceRequestTrackerDetails?.siteVerification?.status?.toString() === 'Assigned',
                    'submitted-building':
                      serviceRequestTrackerDetails?.siteVerification?.status?.toString() === 'Submitted',
                    'approved-building':
                      serviceRequestTrackerDetails?.siteVerification?.status?.toString() === 'Approved',
                    'rejected-building':
                      serviceRequestTrackerDetails?.siteVerification?.status?.toString() === 'Rejected',
                    'suspended-building':
                      serviceRequestTrackerDetails?.siteVerification?.status?.toString() === 'Suspended'
                  }">
                {{ serviceRequestTrackerDetails?.siteVerification?.status?.toString() }}
                </div>
              </div>
              <div class="col-8 header-second-column" *ngIf="
                  serviceRequestTrackerDetails?.siteVerification?.accountCreationStatus?.toString() ===
                    'Approved' && !serviceRequestTrackerDetails?.accountKyc?.hasCustomer
                ">
                <div class="entry-status approval-status new-entry">
                  {{ "COMMON.ACCOUNT_CREATION" | translate }}
                  {{ "COMMON.ASSET_STATUS.APPROVED" | translate | lowercase }}
                </div>
              </div>
              <div class="col-8 header-second-column" *ngIf="
                  serviceRequestTrackerDetails?.siteVerification?.accountCreationStatus?.toString() ===
                  'Pending'
                ">
                <div class="entry-status approval-status submitted-building">
                  {{ "COMMON.ACCOUNT_CREATION" | translate }}
                  {{ "COMMON.ASSET_STATUS.PENDING" | translate | lowercase }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="user-address">
        <div>{{ serviceRequestTrackerDetails?.accountKyc?.email | hasValue }}</div>
        <div>
          +{{ serviceRequestTrackerDetails?.accountKyc?.dialCode | hasValue }}
          {{ serviceRequestTrackerDetails?.accountKyc?.phoneNumber | hasValue }}
        </div>
        <div>
          No.
          {{ serviceRequestTrackerDetails?.accountKyc?.employerAddress?.houseNo | hasValue }}
          {{ serviceRequestTrackerDetails?.accountKyc?.employerAddress?.street | hasValue }}
        </div>
      </div>
    </div>
    <div>
        <button *ngIf="installationStatus === 'Approved'" class="btn btn-header" (click)="downloadPDF()">{{
            "SURVEYS_INSTALLATIONS.DOWNLOAD_INSTALLATION_FORM" |
            translate }}</button>
    </div>
  </div>
<div class="edit-accounts-body row">
    <div class="col-13 col-md-4">
        <div class="row">
            <div class="card container col-11">
                <div class="row">
                    <div class="col-4">
                        {{ "COMMON.MBC_DETAILS.CUSTOMER_NAME" | translate }}
                    </div>
                    <div class="col-8">
                        {{
                        (serviceRequestTrackerDetails?.accountKyc?.surname ?? "") +
                        " " +
                        serviceRequestTrackerDetails?.accountKyc?.firstName | hasValue
                        }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">
                        {{ "COMMON.MBC_DETAILS.CUSTOMER_ADDRESS" | translate }}
                    </div>
                    <div class="col-8">
                        {{ "COMMON.NO." | translate }}
                        {{ serviceRequestTrackerDetails?.accountKyc?.addressOfLandlord?.houseNo | hasValue }}
                        {{ serviceRequestTrackerDetails?.accountKyc?.addressOfLandlord?.street | hasValue }},
                        {{ serviceRequestTrackerDetails?.accountKyc?.addressOfLandlord?.landmark | hasValue }}
                    </div>
                </div>
                <div class="row" *ngIf="
              serviceRequestTrackerDetails?.siteVerification?.accountNumber ||
              serviceRequestTrackerDetails?.accountKyc?.accountNumber
            ">
                    <div class="col-4">
                        {{ "COMMON.CUSTOMER.ACCOUNT_NUMBER" | translate | titlecase }}
                    </div>
                    <div class="col-8">
                        {{
                        serviceRequestTrackerDetails?.accountKyc?.accountNumber ??
                        serviceRequestTrackerDetails?.siteVerification?.accountNumber | hasValue
                        }}
                        <span *ngIf="
                  serviceRequestTrackerDetails?.siteVerification?.accountCreationStatus?.toString() ===
                  'Pending'
                ">
                            <svg width="30" height="30" viewBox="0 0 40 40" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <rect width="30" height="30" rx="20" fill="#FFFFFF" fill-opacity="0.1">
                                    <title>
                                        {{ "COMMON.AWAITING_ACCOUNT_APPROVAL" | translate }}
                                    </title>
                                </rect>
                                <path
                                    d="M20 24V20M20 16H20.01M30 20C30 25.5228 25.5228 30 20 30C14.4772 30 10 25.5228 10 20C10 14.4772 14.4772 10 20 10C25.5228 10 30 14.4772 30 20Z"
                                    stroke="#fc0303" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">
                        {{ "COMMON.MBC_DETAILS.METER_NO" | translate }}
                    </div>
                    <div class="col-8">
                        {{ serviceRequestTrackerDetails?.accountKyc?.meterNumber | hasValue }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">
                        {{ "COMMON.BU.SINGLE" | translate }}
                    </div>
                    <div class="col-8">
                        {{ serviceRequestTrackerDetails?.siteVerification?.area?.regionName | hasValue }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">
                        {{ "COMMON.UT.SINGLE" | translate }}
                    </div>
                    <div class="col-8">
                        {{ serviceRequestTrackerDetails?.siteVerification?.area?.name | hasValue }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-5">{{'COMMON.MBC_DETAILS.FEEDER_NAME' | translate}}</div>
                    <div class="col-7">{{ serviceRequestTrackerDetails?.siteVerification?.dt?.feeder?.name | hasValue }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-5">{{'COMMON.MBC_DETAILS.FEEDER_NUMBER' | translate}}</div>
                    <div class="col-7">
                        {{ serviceRequestTrackerDetails?.siteVerification?.dt?.feeder?.number | hasValue }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">{{'COMMON.DT_NAME' | translate}}</div>
                    <div class="col-8">
                        {{ serviceRequestTrackerDetails?.siteVerification?.dt?.name | hasValue }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-5">{{'COMMON.DT_NUMBER' | translate}}</div>
                    <div class="col-7">{{ serviceRequestTrackerDetails?.siteVerification?.dt?.number | hasValue }}</div>
                </div>
            </div>

            <div class="card container col-11">
                <label class="section-label">{{'SERVICE_POINT_DATA.TITLE' | translate}}</label>
                <div class="row">
                    <div class="col-6">
                        {{'SERVICE_POINT_DATA.REQUIRED_SUPPLY_ADDRESS' | translate}}
                    </div>
                    <div class="col-6">
                        <ng-container *ngIf="serviceRequestTrackerDetails?.accountKyc?.addressOfLandlord?.houseNo">
                            {{'COMMON.NO' | translate}}.
                        </ng-container>
                        {{ serviceRequestTrackerDetails?.accountKyc?.addressOfLandlord?.houseNo | hasValue }}
                        {{ serviceRequestTrackerDetails?.accountKyc?.addressOfLandlord?.street | hasValue }},
                        {{ serviceRequestTrackerDetails?.accountKyc?.addressOfLandlord?.landmark | hasValue }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">{{'SERVICE_POINT_DATA.REGION' | translate}}</div>
                    <div class="col-8">
                        {{ serviceRequestTrackerDetails?.siteVerification?.area?.regionName | hasValue }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">{{'SERVICE_POINT_DATA.AREA' | translate}}</div>
                    <div class="col-8">
                        {{ serviceRequestTrackerDetails?.siteVerification?.area?.name | hasValue }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">{{'SERVICE_POINT_DATA.USE_OF_PREMISES' | translate}}</div>
                    <div class="col-8">
                        {{ serviceRequestTrackerDetails?.accountKyc?.useOfPremises | hasValue }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">{{'SERVICE_POINT_DATA.PREMISES_TYPE' | translate}}</div>
                    <div class="col-8">
                        {{ serviceRequestTrackerDetails?.accountKyc?.typeOfPremises?.toString() | hasValue }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">{{'SERVICE_POINT_DATA.PREMISE_CATEGORY' | translate}}</div>
                    <div class="col-8">
                        {{ serviceRequestTrackerDetails?.accountKyc?.premiseCategory | hasValue }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">{{'SERVICE_POINT_DATA.ACTIVITY' | translate}}</div>
                    <div class="col-8">
                        {{ serviceRequestTrackerDetails?.accountKyc?.activity | hasValue }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">{{'SERVICE_POINT_DATA.SUBACTIVITY' | translate}}</div>
                    <div class="col-8">
                        {{ serviceRequestTrackerDetails?.accountKyc?.subactivity | hasValue }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">{{'SERVICE_POINT_DATA.BUILDING_DEVELOPMENT' | translate}}</div>
                    <div class="col-8">
                        {{ serviceRequestTrackerDetails?.accountKyc?.buildingDevelopmentStage | hasValue }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">{{'SERVICE_POINT_DATA.GEOLOCATION' | translate}}</div>
                    <div class="locationText col-7">
                        <ng-container
                            *ngIf="serviceRequestTrackerDetails?.accountKyc?.latitude != null && serviceRequestTrackerDetails?.accountKyc?.longitude != null; else noServicePointGeolocation">
                            {{ serviceRequestTrackerDetails?.accountKyc?.latitude }}, {{
                            serviceRequestTrackerDetails?.accountKyc?.longitude }}
                        </ng-container>
                        <ng-template #noServicePointGeolocation>
                            {{ '' | hasValue }}
                        </ng-template>
                    </div>
                    <div class="location col-1">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500"
                            (click)="openGeolocationMap(serviceRequestTrackerDetails?.accountKyc?.latitude, serviceRequestTrackerDetails?.accountKyc?.longitude)"
                            [attr.data-bs-toggle]="serviceRequestTrackerDetails?.accountKyc?.latitude != null && serviceRequestTrackerDetails?.accountKyc?.longitude != null ? 'modal' : null"
                            [attr.data-bs-target]="serviceRequestTrackerDetails?.accountKyc?.latitude != null && serviceRequestTrackerDetails?.accountKyc?.longitude != null ? '#showMap' : null">
                            <path
                                d="M256 0c17.7 0 32 14.3 32 32V66.7C368.4 80.1 431.9 143.6 445.3 224H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H445.3C431.9 368.4 368.4 431.9 288 445.3V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V445.3C143.6 431.9 80.1 368.4 66.7 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H66.7C80.1 143.6 143.6 80.1 224 66.7V32c0-17.7 14.3-32 32-32zM128 256c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128s-128 57.3-128 128zm128 80c-44.2 0-80-35.8-80-80s35.8-80 80-80s80 35.8 80 80s-35.8 80-80 80z"
                                fill="#026962" />
                        </svg>
                    </div>
                </div>
            </div>
            <app-user-activity-section
                [kycAccountId]="serviceRequestTrackerDetails?.accountKyc?.id ?? 0"
                [showSurveyInstallation]="true"
                [surveyData]="serviceRequestTrackerDetails?.survey ?? null"
                [installationData]="serviceRequestTrackerDetails?.installation ?? null"></app-user-activity-section>
            <div class="card container col-11">
                <label class="section-label">{{ "USER_ACTIVITY.SURVEY_AND_INSTALLATION" | translate }}</label>
                <div class="row">
                    <div class="col-5">{{ "USER_ACTIVITY.MAP_VENDOR" | translate }}</div>
                    <div class="col-7">{{ serviceRequestTrackerDetails?.survey?.mapVendor | hasValue }}</div>
                </div>
                <div class="row">
                    <div class="col-5">{{ "USER_ACTIVITY.MAP_ID" | translate }}</div>
                    <div class="col-7">{{ serviceRequestTrackerDetails?.survey?.mapId | hasValue }}</div>
                </div>
                <div class="row">
                    <div class="col-5">{{ "USER_ACTIVITY.PROJECT_STATUS" | translate }}</div>
                    <div class="col-7">{{ serviceRequestTrackerDetails?.survey?.projectStatus | hasValue }}</div>
                </div>
                <div class="row">
                    <div class="col-5">{{ "USER_ACTIVITY.PROJECT_DESIGNATION" | translate }}</div>
                    <div class="col-7">{{ (serviceRequestTrackerDetails?.installation != null || serviceRequestTrackerDetails?.survey !=
                        null) ? serviceRequestTrackerDetails?.accountKyc?.projectDesignationName : '' | hasValue }}</div>
                </div>
                <div class="row">
                    <div class="col-5">{{ "USER_ACTIVITY.PAYMENT_STATUS" | translate }}</div>
                    <div class="col-7">{{ serviceRequestTrackerDetails?.survey?.paymentStatus | hasValue }}</div>
                </div>
                <div class="row">
                    <div class="col-5">{{ "USER_ACTIVITY.OLD_METER_NUMBER" | translate }}</div>
                    <div class="col-7">{{ serviceRequestTrackerDetails?.installation?.oldMeterNumber | hasValue }}</div>
                </div>
                <div class="row">
                    <div class="col-5">{{ "USER_ACTIVITY.OLD_METER_BRAND" | translate }}</div>
                    <div class="col-7">{{ serviceRequestTrackerDetails?.installation?.oldMeterBrand | hasValue }}</div>
                </div>
                <div class="row">
                    <div class="col-5">{{ "USER_ACTIVITY.INSTALLED_METER_NUMBER" | translate }}</div>
                    <div class="col-7">{{ serviceRequestTrackerDetails?.installation?.installedMeterNumber | hasValue }}</div>
                </div>
                <div class="row">
                    <div class="col-5">{{ "USER_ACTIVITY.METER_BRAND" | translate }}</div>
                    <div class="col-7">{{ serviceRequestTrackerDetails?.installation?.meterBrand | hasValue }}</div>
                </div>
                <div class="row">
                    <div class="col-5">{{ "USER_ACTIVITY.METER_PHASE" | translate }}</div>
                    <div class="col-7">{{ serviceRequestTrackerDetails?.installation?.meterPhase | hasValue }}</div>
                </div>
                <div class="row">
                    <div class="col-5">{{ "USER_ACTIVITY.SIM_NUMBER" | translate }}</div>
                    <div class="col-7">{{ serviceRequestTrackerDetails?.installation?.simNumber | hasValue }}</div>
                </div>
                <div class="row">
                    <div class="col-5">{{ "USER_ACTIVITY.PRELOADED_UNIT" | translate }}</div>
                    <div class="col-7">{{ serviceRequestTrackerDetails?.installation?.preloadedUnit | hasValue }}</div>
                </div>
                <div class="row">
                    <div class="col-5">{{ "USER_ACTIVITY.SEAL_NUMBER" | translate }}</div>
                    <div class="col-7">{{ serviceRequestTrackerDetails?.installation?.sealNumber | hasValue }}</div>
                </div>
            </div>
        </div>
    </div>

    <div class="col-13 col-md-4">
        <div class="row">
            <div class="card container col-11" *ngIf="serviceRequestTrackerDetails?.siteVerification">
                <label class="section-label">{{
                    "ROLE_MANAGEMENT.SITE_VERIFICATION" | translate
                    }}</label>
                <div class="row">
                    <div class="col-4">
                        {{ "COMMON.MBC_DETAILS.TYPE_OF_CONNECTION" | translate }}
                    </div>
                    <div class="col-8">
                        {{ serviceRequestTrackerDetails?.siteVerification?.typeOfConnection | hasValue }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-5">{{ "COMMON.MBC_DETAILS.FEEDER_NAME" | translate }}</div>
                    <div class="col-7">{{ serviceRequestTrackerDetails?.siteVerification?.dt?.feeder?.name | hasValue }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-5">
                        {{ "COMMON.MBC_DETAILS.FEEDER_NUMBER" | translate }}
                    </div>
                    <div class="col-7">
                        {{ serviceRequestTrackerDetails?.siteVerification?.dt?.feeder?.number | hasValue }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">{{ "COMMON.DT_NAME" | translate }}</div>
                    <div class="col-8">
                        {{ serviceRequestTrackerDetails?.siteVerification?.dt?.name | hasValue }}
                    </div>
        </div>
        <div class="row">
            <div class="col-5">{{'COMMON.DT_NUMBER' | translate}}</div>
            <div class="col-7">{{ serviceRequestTrackerDetails?.siteVerification?.dt?.number | hasValue }}</div>
        </div>
        <div class="row">
            <div class="col-4">
                {{ "COMMON.CONNECTION_TYPE" | translate }}
                </div>
                <div class="col-8">
                    {{ serviceRequestTrackerDetails?.siteVerification?.connectionType | hasValue }}
                </div>
                </div>
                <div class="row">
                    <div class="col-4">
                        {{ "COMMON.TYPE_OF_CABLE" | translate }}
                    </div>
                    <div class="col-8">
                        {{ serviceRequestTrackerDetails?.siteVerification?.typeOfCable | hasValue }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">
                        {{ "COMMON.CONNECTION_POSSIBLE" | translate }}
                    </div>
                    <div class="col-8">
                        {{ serviceRequestTrackerDetails?.siteVerification?.connectionPossible | hasValue }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">
                        {{ "COMMON.NEED_FOR_POLE" | translate }}
                    </div>
                    <div class="col-8">
                        {{ serviceRequestTrackerDetails?.siteVerification?.needForPole | hasValue }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">
                {{ "COMMON.MBC_DETAILS.NEIGHBORHOOD" | translate }}
                {{ "COMMON.TARIFF.CLASS" | translate | lowercase }}
            </div>
            <div class="col-8">
                {{ serviceRequestTrackerDetails?.siteVerification?.neighborhood | hasValue }}
            </div>
        </div>
        <div class="row">
            <div class="col-4">
                {{ "COMMON.MBC_DETAILS.NUMBER_OF_ROOMS" | translate }}
            </div>
            <div class="col-8">
                {{ serviceRequestTrackerDetails?.siteVerification?.numberOfRooms | hasValue }}
            </div>
        </div>
        <div class="row">
            <div class="col-4">
                {{ "COMMON.SLT_STATUS.SINGLE" | translate }}
            </div>
            <div class="col-8">
                {{ serviceRequestTrackerDetails?.siteVerification?.sltStatusValue | hasValue }}
            </div>
        </div>
        <div class="row">
            <div class="col-4">{{ "COMMON.TARIFF.SINGLE" | translate }}</div>
            <div class="col-8">
                {{ serviceRequestTrackerDetails?.siteVerification?.tariff | hasValue }}
            </div>
        </div>
        <div class="row">
            <div class="col-4">
                {{ "COMMON.TABLE_HEADERS.METER_TYPE" | translate }}
            </div>
            <div class="col-8">
                {{ serviceRequestTrackerDetails?.siteVerification?.meterBrand | hasValue }}
            </div>
        </div>
        <div class="row">
            <div class="col-4">
                {{ "COMMON.MBC_DETAILS.CLIENT_TYPE" | translate }}
            </div>
            <div class="col-8">
                {{ serviceRequestTrackerDetails?.siteVerification?.clientType | hasValue }}
            </div>
        </div>
        <div class="row">
            <div class="col-5">
                {{ "SITE_VERIFICATION.REMARK" | translate }}
            </div>
            <div class="col-7">
                {{ serviceRequestTrackerDetails?.siteVerification?.remark | hasValue }}
            </div>
        </div>
        <div class="row" *ngIf="serviceRequestTrackerDetails?.siteVerification?.remark">
            <div class="col-5">
                {{ "SITE_VERIFICATION.REASON" | translate }}
            </div>
            <div *ngIf="serviceRequestTrackerDetails?.siteVerification?.remark == 'Reject'" class="col-7">
                {{ serviceRequestTrackerDetails?.siteVerification?.rejectionReason | hasValue }}
            </div>
            <div *ngIf="serviceRequestTrackerDetails?.siteVerification?.remark == 'Suspend'" class="col-7">
                {{ serviceRequestTrackerDetails?.siteVerification?.suspensionReason | hasValue }}
            </div>
        </div>
        <div class="row">
            <div class="col-5">
                {{ "COMMON.MBC_DETAILS.GEO_LOCATION" | translate }}
            </div>
            <div class="locationText col-6">
                {{ serviceRequestTrackerDetails?.siteVerification?.latitude }},
                {{ serviceRequestTrackerDetails?.siteVerification?.longitude }}
            </div>
            <div class="location col-1">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500"
                    (click)="openGeolocationMap(serviceRequestTrackerDetails?.siteVerification?.latitude, serviceRequestTrackerDetails?.siteVerification?.longitude)"
                    [attr.data-bs-toggle]="serviceRequestTrackerDetails?.siteVerification?.latitude != null && serviceRequestTrackerDetails?.siteVerification?.longitude != null ? 'modal' : null"
                    [attr.data-bs-target]="serviceRequestTrackerDetails?.siteVerification?.latitude != null && serviceRequestTrackerDetails?.siteVerification?.longitude != null ? '#showMap' : null">
                    <path
                        d="M256 0c17.7 0 32 14.3 32 32V66.7C368.4 80.1 431.9 143.6 445.3 224H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H445.3C431.9 368.4 368.4 431.9 288 445.3V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V445.3C143.6 431.9 80.1 368.4 66.7 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H66.7C80.1 143.6 143.6 80.1 224 66.7V32c0-17.7 14.3-32 32-32zM128 256c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128s-128 57.3-128 128zm128 80c-44.2 0-80-35.8-80-80s35.8-80 80-80s80 35.8 80 80s-35.8 80-80 80z"
                        fill="#026962" />
                </svg>
            </div>
        </div>
        </div>
        
        <div class="card container col-11">
            <label class="section-label">{{'CUSTOMER_DATA.TITLE' | translate}}</label>
            <div class="row">
                <div class="col-5">{{ 'CUSTOMER_DATA.ACC_NAME' | translate }}</div>
                <div class="col-7">
                    {{ (serviceRequestTrackerDetails?.accountKyc?.surname + ' ' +
                    serviceRequestTrackerDetails?.accountKyc?.firstName) | hasValue }}
                </div>
            </div>
            <div class="row">
                <div class="col-5">{{'PERSONAL_DATA.CUSTOMER_PHONE_NO' | translate}}</div>
                <div class="col-7">
                    <p>
                        <ng-container *ngIf="serviceRequestTrackerDetails?.accountKyc?.buildingOwnerDialCode">
                            +
                        </ng-container>
                        {{ serviceRequestTrackerDetails?.accountKyc?.dialCode | hasValue }}
                        {{ serviceRequestTrackerDetails?.accountKyc?.phoneNumber | hasValue }}
                    </p>
                </div>
            </div>
            <div class="row">
                <div class="col-5">{{ 'CUSTOMER_DATA.EMAIL' | translate }}</div>
                <div class="col-7">
                    {{ serviceRequestTrackerDetails?.accountKyc?.email }}
                </div>
            </div>
            <div class="row">
                <div class="col-5">{{ 'CUSTOMER_DATA.OWNERSHIP_STATUS' | translate }}</div>
                <div class="col-7">
                    {{ serviceRequestTrackerDetails?.accountKyc?.ownershipStatus | hasValue }}
                </div>
            </div>
            <div class="row">
                <div class="col-6">{{ 'CUSTOMER_DATA.BUILDING_OWNER' | translate }}</div>
                <div class="col-6">
                    {{ serviceRequestTrackerDetails?.accountKyc?.buildingOwner | hasValue }}
                </div>
            </div>
            <div class="row">
                <div class="col-5">{{ 'CUSTOMER_DATA.CUSTOMER_IDENTIFICATION' | translate }}</div>
                <div class="col-7">
                    {{ serviceRequestTrackerDetails?.accountKyc?.identificationOfLandlord | hasValue }}
                </div>
            </div>
            <div class="row">
                <div class="col-5">{{ 'CUSTOMER_DATA.PERSONAL_ID_NUM' | translate }}</div>
                <div class="col-7">
                    {{ serviceRequestTrackerDetails?.accountKyc?.personalIdNumberOfLandlord | hasValue }}
                </div>
            </div>
            <div class="row">
                <div class="col-4">{{ 'CUSTOMER_DATA.DATE_OF_BIRTH' | translate }}</div>
                <div class="col-8">
                    {{ serviceRequestTrackerDetails?.accountKyc?.dateOfBirth | date : "dd/MM/yyyy" }}
                </div>
            </div>
            <div class="row">
                <div class="col-5">{{ 'CUSTOMER_DATA.NATIONALITY' | translate }}</div>
                <div class="col-7">
                    {{ serviceRequestTrackerDetails?.accountKyc?.nationality | hasValue }}
                </div>
            </div>
            <div class="row">
                <div class="col-5">{{ 'CUSTOMER_DATA.GENDER' | translate }}</div>
                <div class="col-7">
                    {{ serviceRequestTrackerDetails?.accountKyc?.gender | hasValue }}
                </div>
            </div>
            <div class="row">
                <div class="col-5">{{ 'CUSTOMER_DATA.NIN' | translate }}</div>
                <div class="col-7">
                    {{ serviceRequestTrackerDetails?.accountKyc?.nin | hasValue }}
                    <app-nin-verification-popup [nin]="serviceRequestTrackerDetails?.accountKyc?.nin"
                        [accountId]="serviceRequestTrackerDetails?.siteVerification?.accountKYCId"></app-nin-verification-popup>
                </div>
            </div>
            <div class="row">
                <div class="col-4">{{'SERVICE_POINT_DATA.SERVICE_TYPE' | translate}}</div>
                <div class="col-8">
                    {{ serviceRequestTrackerDetails?.accountKyc?.serviceType | hasValue }}
                </div>
            </div>
            <div class="row">
                <div class="col-4">{{'SERVICE_POINT_DATA.SUB_SERVICE_TYPE' | translate}}</div>
                <div class="col-8">
                    {{ subServieSpaces(serviceRequestTrackerDetails?.accountKyc?.subServiceType) | hasValue }}
                </div>
            </div>
            <div *ngIf="serviceRequestTrackerDetails?.accountKyc?.identificationIssueDate" class="row">
                <div class="col-5">Identification Issue Date</div>
                <div class="col-7">
                    {{ serviceRequestTrackerDetails?.accountKyc?.identificationIssueDate | date : "dd/MM/yyyy" }}
                </div>
            </div>
            <div *ngIf="serviceRequestTrackerDetails?.accountKyc?.identificationExpiryDate" class="row">
                <div class="col-5">Identification Expiry Date</div>
                <div class="col-7">
                    {{ serviceRequestTrackerDetails?.accountKyc?.identificationExpiryDate | date : "dd/MM/yyyy" }}
                </div>
            </div>
            <div class="row">
                <div class="col-5">Customer Type</div>
                <div class="col-7">
                    {{ customerType | hasValue }}
                </div>
            </div>
            <div class="row">
                <div class="col-5">Client Type</div>
                <div class="col-7">
                    {{ clientType | hasValue }}
                </div>
            </div>
        </div>
        
        <div class="card container col-11">
            <label class="section-label">{{
                "PERSONAL_DATA.DECLARATION" | translate
                }}</label>
            <div class="row" *ngFor="
                      let loadItem of serviceRequestTrackerDetails?.accountKyc?.loadRequirements
                    ">
                <div class="col-6">
                    {{ loadItem.name }}
                </div>
                <div class="col-2">
                    {{ loadItem.number }}
                </div>
                <div class="col-4">
                    {{ loadItem.wattage }}
                </div>
            </div>
            <div class="row">
                <div class="col-6">Total load</div>
                <div class="col-2">
                    ----
                </div>
                <div class="col-4">
                    {{ totalLoad }}
                </div>
            </div>
        </div>
        
        <app-meter-request-section class="card"
            [relatedAccounts]="serviceRequestTrackerDetails?.accountKyc?.relatedAccounts"
            [accountKycId]="serviceRequestTrackerDetails?.accountKyc?.id ?? 0"></app-meter-request-section>
        </div>
        </div>
        
        <div class="image-container col-13 col-md-4">
            <div class="card container">
                <div>{{ "COMMON.PICTURES.FRONT" | translate }}</div>
                <div class="images-list">
                    <div>
                        <img *ngIf="getFrontViewImage(0)" src="{{ getFrontViewImage(0) }}" (click)="showImage(0)"
                            data-bs-toggle="modal" data-bs-target="#modalImage" alt="Item image" />
                        <img *ngIf="!getFrontViewImage(0)" class="no-image" src="{{ placeholderImage }}"
                            alt="Placeholder image" />
                    </div>
                    <div *ngIf="areLocationImagesVisible">
                        <img *ngIf="getFrontViewImage(1)" src="{{ getFrontViewImage(1) }}" (click)="showImage(1)"
                            data-bs-toggle="modal" data-bs-target="#modalImage" alt="Item image" />
                        <img *ngIf="!getFrontViewImage(1)" class="no-image" src="{{ placeholderImage }}"
                            alt="Placeholder image" />
                    </div>
                    <div *ngIf="areLocationImagesVisible">
                        <img *ngIf="getFrontViewImage(2)" src="{{ getFrontViewImage(2) }}" (click)="showImage(2)"
                            data-bs-toggle="modal" data-bs-target="#modalImage" alt="Item image" />
                        <img *ngIf="!getFrontViewImage(2)" class="no-image" src="{{ placeholderImage }}"
                            alt="Placeholder image" />
                    </div>
                </div>
            </div>
            <div class="card container" *ngIf="areLocationImagesVisible">
                <div>{{ "COMMON.PICTURES.MOUNTED_TAG" | translate }}</div>
                <div>
                    <div>
                        <img *ngIf="getBuildingMountedImage()" src="{{ getBuildingMountedImage() }}" (click)="showImage(3)"
                            data-bs-toggle="modal" data-bs-target="#modalImage" alt="Item image" />
                        <img *ngIf="!getBuildingMountedImage()" class="no-image" src="{{ placeholderImage }}"
                            alt="Placeholder image" />
                    </div>
                </div>
            </div>
            <div class="card container"
                *ngIf="serviceRequestTrackerDetails?.accountKyc?.clientTypeString == 'Individual' && areLocationImagesVisible">
                <div>{{ "COMMON.PICTURES.CUSTOMER_ID_CARD" | translate }}</div>
                <div class="images-list">
                    <div>
                        <img *ngIf="serviceRequestTrackerDetails?.accountKyc?.applicantsSignitureUrl"
                            src="{{ serviceRequestTrackerDetails?.accountKyc?.applicantsSignitureUrl }}" (click)="showImage(8)"
                            data-bs-toggle="modal" data-bs-target="#modalImage" alt="Item image" />
                        <img *ngIf="!serviceRequestTrackerDetails?.accountKyc?.applicantsSignitureUrl" class="no-image"
                            src="{{ placeholderImage }}" alt="Placeholder image" />
                    </div>
                </div>
            </div>
            <div class="card container" *ngIf="areLocationImagesVisible">
                <div>{{ "COMMON.PICTURES.CUT_OUT" | translate }}</div>
                <div>
                    <div>
                        <img *ngIf="getCutOutImage()" src="{{ getCutOutImage() }}" (click)="showImage(10)"
                            data-bs-toggle="modal" data-bs-target="#modalImage" alt="Item image" />
                        <img *ngIf="!getCutOutImage()" class="no-image" src="{{ placeholderImage }}" alt="Placeholder image" />
                    </div>
                </div>
            </div>
            <div class="card container">
                <div>{{ "COMMON.PICTURES.UTILITY_SUPPLY" | translate }}</div>
                <div>
                    <div>
                        <img *ngIf="getUtilitySupplyImage()" src="{{ getUtilitySupplyImage() }}" (click)="showImage(11)"
                            data-bs-toggle="modal" data-bs-target="#modalImage" alt="Item image" />
                        <img *ngIf="!getUtilitySupplyImage()" class="no-image" src="{{ placeholderImage }}"
                            alt="Placeholder image" />
                    </div>
                </div>
            </div>
            <div class="card container">
                <div>
                    <div>
                        {{ "COMMON.PICTURES.ELECT_CONTRACTOR_SIGNATURE" | translate }}
                    </div>
                    <div class="images-list">
                        <button class="btn btn-outline-dark"
                            (click)="openPdf(serviceRequestTrackerDetails?.accountKyc?.electricalContractorsSignitureUrl ?? '')">View
                            PDF</button>
                    </div>
                </div>
            </div>
            <div class="card container">
                <div>{{ "COMMON.PICTURES.APPLICANT_PASSPORT" | translate }}</div>
                <div class="images-list">
                    <div>
                        <img *ngIf="serviceRequestTrackerDetails?.accountKyc?.passportUrl; else noImage"
                            src="{{ serviceRequestTrackerDetails?.accountKyc?.passportUrl }}" (click)="showImage(9)"
                            data-bs-toggle="modal" data-bs-target="#modalImage" alt="Item image" />
                    </div>
                </div>
            </div>
            <div class="card container" *ngIf="serviceRequestTrackerDetails?.accountKyc?.ownershipStatus == 'Owner'">
                <div>{{'COMMON.PDF.PROOF_OWNERSHIP' | translate}}</div>
                <div class="images-list">
                    <div>
                        <button class="btn btn-outline-dark"
                            (click)="openPdf(serviceRequestTrackerDetails?.accountKyc?.proofOfOwnershipUrl ?? '')">View
                            PDF</button>
                    </div>
                </div>
            </div>
            <div class="card container" *ngIf="serviceRequestTrackerDetails?.accountKyc?.ownershipStatus == 'Tenant'">
                <div>{{'COMMON.PDF.LETTER_CONSENT' | translate}}</div>
                <div class="images-list">
                    <div>
                        <button class="btn btn-outline-dark"
                            (click)="openPdf(serviceRequestTrackerDetails?.accountKyc?.letterOfConsentUrl ?? '')">View
                            PDF</button>
                    </div>
                </div>
            </div>
            <div class="card container" *ngIf="serviceRequestTrackerDetails?.accountKyc?.ownershipStatus == 'Tenant'">
                <div>{{'COMMON.PDF.AGREEMENT' | translate}}</div>
                <div class="images-list">
                    <div>
                        <button class="btn btn-outline-dark"
                            (click)="openPdf(serviceRequestTrackerDetails?.accountKyc?.tenancyAgreementUrl ?? '')">View
                            PDF</button>
                    </div>
                </div>
            </div>
            <div class="card container"
                *ngIf="serviceRequestTrackerDetails?.accountKyc?.clientTypeString != 'Individual' && serviceRequestTrackerDetails?.accountKyc?.clientType != null">
                <div>{{'COMMON.PDF.LETTER_AUTHRIZATION' | translate}}</div>
                <div class="images-list">
                    <div>
                        <button class="btn btn-outline-dark"
                            (click)="openPdf(serviceRequestTrackerDetails?.accountKyc?.letterOfAuthorizationUrl ?? '')">View
                            PDF</button>
                    </div>
                </div>
            </div>
        </div>
        </div>
        
        <div class="modal fade" id="modalImage" tabindex="-1" aria-hidden="true" (hidden.bs.modal)="onModalFade()"
            (shown.bs.modal)="onModalOpen()">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content modal-image">
                    <div class="modal-body modal-body-image">
                        <div class="image-container" [style.transform]="'rotate(' + currentRotation + 'deg)'">
                            <lib-ngx-image-zoom [zoomMode]="'hover-freeze'" [fullImage]="selectedImage"
                                [thumbImage]="selectedImage" [magnification]="3">
                            </lib-ngx-image-zoom>
                        </div>
                        <div class="rotate-div">
                            <button class="btn btn-primary left-button" (click)="rotateLeft()">
                                &lt;
                            </button>
                            <button class="btn btn-primary right-button" (click)="rotateRight()">
                                &gt;
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="modal modalMap" id="showMap" tabindex="-1" aria-hidden="true" (shown.bs.modal)="onGeolocationMapModalOpen()"
            (hidden.bs.modal)="onGeolocationMapModalFade()">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <app-geolocation-map-viewer *ngIf="selectedMapLatitude != null && selectedMapLongitude != null"
                            [setMapVisibility]="isGeolocationMapVisible" [longitude]="selectedMapLongitude"
                            [latitude]="selectedMapLatitude"></app-geolocation-map-viewer>
                    </div>
                </div>
            </div>
        </div>
        
        <ng-template #noImage>
            <img class="no-image" src="{{ placeholderImage }}" alt="Placeholder image" />
        </ng-template>
        </div>